import { useCallback, useContext } from 'react';

import { AutocompleteValue } from '@mui/base/AutocompleteUnstyled/useAutocomplete';
import { Chip } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import {
  GridRenderEditCellParams,
  useGridApiContext,
} from '@mui/x-data-grid-pro';
import { observer } from 'mobx-react-lite';
import {
  icon,
  checkedIcon,
} from 'src/pages/EdibleFoodRecoveryDetails/components/FoodWillingType';
import { lookupsStoreCtx } from 'src/stores/lookups';
import { ItemType } from 'src/types';
import { isPending } from 'src/utils/common';

export const SelectContainerTypes = observer(
  ({ value, field, id, api, row }: GridRenderEditCellParams) => {
    const { containerTypeReq, containerTypes, assetSubCategories } =
      useContext(lookupsStoreCtx);
    const apiRef = useGridApiContext();
    const allowToEdit: boolean =
      (value.lenght ||
        api.state.editRows[id].subCategory?.value?.containerTypesAllowed) ??
      !!assetSubCategories.find(el => el.id === row.subCategory?.id)
        ?.containerTypesAllowed;

    const handleChange = useCallback(
      async (data: AutocompleteValue<ItemType, {}, {}, {}>) => {
        return await apiRef.current.setEditCellValue({
          id,
          field,
          value: data,
        });
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [],
    );

    const loading = isPending(containerTypeReq);
    if (!allowToEdit) return null;
    return (
      <Autocomplete
        multiple
        fullWidth
        value={value}
        defaultValue={value}
        onChange={(_, data) => handleChange(data)}
        getOptionLabel={option => option?.name || ''}
        isOptionEqualToValue={(option, value) =>
          `${option.id}` === `${value.id}`
        }
        limitTags={1}
        disableCloseOnSelect
        options={containerTypes}
        slotProps={{
          popper: { sx: { zIndex: 0 } },
        }}
        renderTags={(tagValue, getTagProps) => {
          return tagValue.map((option, index) => (
            <Chip
              size="small"
              sx={{ borderRadius: 1 }}
              label={option.name}
              {...getTagProps({ index })}
            />
          ));
        }}
        renderOption={(props, option, { selected }) => (
          <MenuItem {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              checked={selected}
            />
            <ListItemText primary={option.name} />
          </MenuItem>
        )}
        loading={loading}
        renderInput={params => (
          <TextField
            {...params}
            placeholder="Select department waiver"
            sx={{ p: 0, border: 0 }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    );
  },
);
